import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { orgPrefsReminder, UPDATE_SCENARIO_EOL_TITLE, welcomeText } from '../constants';
export interface ConfirmPayload {
  title: string;
  text: string;
  iconHtml: string;
  icon?: 'warning' | 'error' | 'success' | 'info' | 'question';
  allowOutsideClick?: boolean;
  reverseButtons?: boolean;
  showCancelButton?: boolean;
  showConfirmButton?: boolean;
  customClass?: string;
  iconColor?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  enableAnimation?: boolean;
}
@Injectable({
  providedIn: 'root',
})
export class SwalService {
  confirm(
    title: string,
    text: string,
    menu?: string,
    isEOL?: any,
    checkReport?: any
  ): Promise<boolean> {
    const confirmButtonText =
      title.toLowerCase() === 'would you like to replace it?' ||
      title.toLowerCase() == 'report this issue' ||
      title == 'License level' ||
      title == 'License level mismatch' ||
      title.toLowerCase() == 'unsaved changes'
        ? 'Yes'
        : title.toLowerCase() === 'scenario confirmation' ||
          menu?.toLowerCase() === 'organization' ||
          title.toLowerCase() === 'pallet configuration' ||
          title.toLowerCase() === "you're good to go!"
        ? 'Yes'
        : title.toLowerCase() === 'warning' || title === welcomeText
        ? 'Okay'
        : title == orgPrefsReminder
        ? 'Take me there'
        : title.toLowerCase() == 'session expiring soon'
        ? 'Extend'
        : title == UPDATE_SCENARIO_EOL_TITLE
        ? 'Proceed'
        : 'Delete';

    const cancelButtonText =
      title.toLowerCase() === 'would you like to replace it?' ||
      title.toLowerCase() == 'report this issue' ||
      title == 'License level' ||
      title.toLowerCase() == 'unsaved changes'
        ? 'No'
        : title.toLowerCase() === 'scenario confirmation' ||
          menu?.toLowerCase() === 'organization' ||
          title.toLowerCase() === 'pallet configuration' ||
          title.toLowerCase() === "you're good to go!"
        ? 'No'
        : title.toLowerCase() === 'scenario confirmation' ||
          menu?.toLowerCase() === 'organization' ||
          title.toLowerCase() === 'pallet configuration' ||
          title.toLowerCase() === "you're good to go!"
        ? 'No'
        : title.toLowerCase() == 'session expiring soon'
        ? 'Understood'
        : title == 'License level mismatch'
        ? 'Update'
        : 'Cancel';
    return Swal.fire({
      title,
      html:
        title == welcomeText
          ? `<span title="${text}"></span>
       <p class="pb-0 mb-0">To get you started, here is a tour of the tool.</p> 
      `
          : `<span title="${text}">${text}</span>`,
      icon: isEOL ? undefined : 'warning',
      iconHtml: isEOL ? '<img src="/assets/images/warning-eol.svg" class="custom-icon">' : '',
      showClass: {
        backdrop: 'swal2-noanimation', // disable backdrop animation
        popup: '', // disable popup animation
        icon: '', // disable icon animation
      },
      hideClass: {
        popup: '', // disable popup fade-out animation
      },
      showCancelButton: isEOL ? false : true,
      showConfirmButton: checkReport ? false : true,
      confirmButtonText,
      allowOutsideClick: false,
      cancelButtonText,
      reverseButtons: true,
      customClass:
        title == 'Warning'
          ? 'Popupbackground eol-warning'
          : title == 'Report validation'
          ? 'Popupbackground report-validation-text'
          : title == welcomeText
          ? 'Popupbackground guided-tour welcome-txt'
          : title == orgPrefsReminder
          ? 'Popupbackground admin-reminder-txt'
          : 'Popupbackground',
      iconColor: isEOL ? '#FFFFFF' : '',
    }).then(result => {
      return result.isConfirmed;
    });
  }

  // Alternative method that maintains backward compatibility
  confirmLegacy(payload: ConfirmPayload): Promise<boolean> {
    const {
      title,
      text,
      icon = 'warning',
      allowOutsideClick = false,
      reverseButtons = false,
      showCancelButton = true,
      showConfirmButton = true,
      customClass = 'Popupbackground',
      iconColor,
      iconHtml = '',
      confirmButtonText,
      cancelButtonText,
      enableAnimation = false,
    } = payload;
    return Swal.fire({
      title,
      html: `<span>${text}</span>`,
      icon,
      iconHtml,
      showClass: {
        backdrop: 'swal2-noanimation', // disable backdrop animation
        popup: '', // disable popup animation
        icon: '', // disable icon animation
      },
      hideClass: {
        popup: '', // disable popup fade-out animation
      },
      showCancelButton,
      showConfirmButton,
      confirmButtonText,
      allowOutsideClick,
      cancelButtonText,
      reverseButtons,
      customClass,
      iconColor,
    }).then(result => {
      return result.isConfirmed;
    });
  }

  confirmNew(
    title: string,
    text: string,
    menu?: string,
    isEOL?: any,
    checkReport?: any
  ): Promise<{ confirmed: boolean; cancelled: boolean; dismissedBy?: string }> {
    const confirmButtonText =
      title.toLowerCase() === 'would you like to replace it?' ||
      title.toLowerCase() === 'report this issue'
        ? 'Yes'
        : title.toLowerCase() === 'scenario confirmation' ||
          menu?.toLowerCase() === 'organization' ||
          title.toLowerCase() === 'pallet configuration' ||
          title.toLowerCase() === "you're good to go!"
        ? 'Yes'
        : title.toLowerCase() === 'warning' || title === welcomeText
        ? 'Okay'
        : title === orgPrefsReminder
        ? 'Take me there'
        : title.toLowerCase() === 'session expiring soon'
        ? 'Extend'
        : 'Delete';

    const cancelButtonText =
      title.toLowerCase() === 'would you like to replace it?' ||
      title.toLowerCase() === 'report this issue'
        ? 'No'
        : title.toLowerCase() === 'scenario confirmation' ||
          menu?.toLowerCase() === 'organization' ||
          title.toLowerCase() === 'pallet configuration' ||
          title.toLowerCase() === "you're good to go!"
        ? 'No'
        : title.toLowerCase() === 'session expiring soon'
        ? 'Understood'
        : 'Cancel';

    return Swal.fire({
      title,
      html:
        title === welcomeText
          ? `<span title="${text}"></span><p class="pb-0 mb-0">To get you started, here is a tour of the tool.</p>`
          : `<span title="${text}">${text}</span>`,
      icon: isEOL ? undefined : 'warning',
      iconHtml: isEOL ? '<img src="/assets/images/warning-eol.svg" class="custom-icon">' : '',
      showClass: {
        backdrop: 'swal2-noanimation',
        popup: '',
        icon: '',
      },
      hideClass: {
        popup: '',
      },
      showCancelButton: !isEOL,
      showConfirmButton: !checkReport,
      confirmButtonText,
      cancelButtonText,
      allowOutsideClick: false,
      reverseButtons: true,
      customClass:
        title === 'Warning'
          ? 'Popupbackground eol-warning'
          : title === 'Report validation'
          ? 'Popupbackground report-validation-text'
          : title === welcomeText
          ? 'Popupbackground guided-tour welcome-txt'
          : title === orgPrefsReminder
          ? 'Popupbackground admin-reminder-txt'
          : 'Popupbackground',
      iconColor: isEOL ? '#FFFFFF' : '',
    }).then(result => {
      return {
        confirmed: result.isConfirmed,
        cancelled: result.isDismissed,
        dismissedBy: result.dismiss ? String(result.dismiss) : undefined,
      };
    });
  }
}
